import { ABS_PRODUCT_ID, HYC_PRODUCT_ID, IGC_PRODUCT_ID } from '@/creditflowresearch/domain/Product/constants';
import type { ExpandStrategy } from './expandStrategy';

const PRODUCT_EXPAND_CONFIG: Record<string, ExpandStrategy> = {
  [ABS_PRODUCT_ID]: { type: 'all' },
  [HYC_PRODUCT_ID]: { type: 'none' },
  [IGC_PRODUCT_ID]: { type: 'none' },
};

const DEFAULT_EXPAND_STRATEGY: ExpandStrategy = { type: 'none' };

const getExpandStrategy = (productId: string): ExpandStrategy => {
  return PRODUCT_EXPAND_CONFIG[productId] ?? DEFAULT_EXPAND_STRATEGY;
};

export { getExpandStrategy, PRODUCT_EXPAND_CONFIG, DEFAULT_EXPAND_STRATEGY };
